import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { MAINTENANCE_SOURCE } from "@/constants/MaintenanceSource";
import { MaintenanceWorkOrderJob } from "@/models/MaintenanceWorkOrderJob";

const TERMINAL_STATUS_CODES = [5, 6];
const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

export function usePmJobsByDevice(deviceId: string) {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery<MaintenanceWorkOrderJob[]>({
    queryKey: ["pmJobsByDevice", activeSessionId, deviceId],
    enabled: Boolean(deviceId),
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    queryFn: ({ signal }) => {
      const now = new Date();
      return (
        geotabClient.call(
          "Get",
          {
            typeName: "MaintenanceWorkOrderJob",
            search: {
              deviceSearch: { id: deviceId, fromDate: now },
              fromDateCompleted: new Date(now.getTime() - ONE_YEAR_MS),
              toDateCompleted: new Date(now.getTime() + ONE_YEAR_MS),
            },
          },
          signal,
        ) as unknown as Promise<MaintenanceWorkOrderJob[]>
      ).then(jobs =>
        jobs.filter(
          j =>
            j?.maintenanceType?.source === MAINTENANCE_SOURCE.ECO_PM &&
            !TERMINAL_STATUS_CODES.includes(j?.statusCode ?? 0),
        ),
      );
    },
  });
}

export function findPmJob(
  jobs: MaintenanceWorkOrderJob[] | undefined,
  pmTitle: string,
): MaintenanceWorkOrderJob | null {
  if (!pmTitle || !jobs?.length) return null;
  return jobs.find(j => j?.maintenanceType?.name === pmTitle) ?? null;
}
